import { useEffect, useState } from "react";
import axios from "axios";
import { BsArrowLeft } from "react-icons/bs";
import DayQuestion from "./DayQuestion";
import { fetchUpcomingBookedList } from "../../../services/getBookingList";
import { base_url, razorpay_key } from "../../../config";
import ThankYou from "../details/listeningDetails/ThankYou";
import TableCard from "./TableCard";
import { FaArrowLeft } from "react-icons/fa6";
import UpcomingTable from "./upcomingTable/UpcomingTable";
import { toast } from "react-toastify";
import ReactPixel from 'react-facebook-pixel';
import ConcertCard from "../../shared/concertCard/ConcertCard";
import { useNavigate } from "react-router-dom";
import { FaCalendarWeek } from "react-icons/fa";

const AREAS = [
  // { key: "south", label: "South Bangalore" },
  // { key: "north", label: "North Bangalore" },
  { key: "center", label: "Central/South Bangalore" },
];

// Map UI area keys to API values (api uses "South", "North", "Central")
const AREA_MAP = {
  south: "South",
  north: "North",
  center: "Central",
};

const ShowTable = ({ onBack }) => {

  const navigate = useNavigate();

  const [step, setStep] = useState(0); // 0 = area, 1 = price, 2 = results
  const [preferredDay, setPreferredDay] = useState(null); // { label, iso }
  const [selectedDay, setSelectedDay] = useState(null); // { label, iso }
  const [area, setArea] = useState(null); // for UI only
  const [priceRange, setPriceRange] = useState(null);
  const [priceRanges, setPriceRanges] = useState([]);
  const [tables, setTables] = useState([]);
  const [hostTables, setHostTables] = useState([]);
  const [eventDates, setEventDates] = useState(null);
  const [eventDatesHost, setEventDatesHost] = useState(null);
  const [upcomingBooking, setUpcomingBooking] = useState(null);
  const [upcomingTableList, setUpcomingTableList] = useState([]);
  const [candidateTables, setCandidateTables] = useState([]); // tables filtered by date+area
  const [filteredTables, setFilteredTables] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const accessToken = localStorage.getItem("@user");
  const [bookedMap, setBookedMap] = useState({});
  const [payedMap, setPayedMap] = useState({});
  const [orderMap, setOrderMap] = useState({});
  const [loginModal, setLoginModal] = useState(false);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const token = localStorage.getItem("@user");
  const [thanksModal, setThanksModal] = useState(false);
  const [status, setStatus] = useState(null);

  const parseRange = (r) => {
    if (!r) return { low: Infinity, high: Infinity };
    const s = String(r).trim();
    if (s.endsWith("+")) {
      const n = parseInt(s.replace("+", "").replace(/[^0-9]/g, ""), 10);
      return { low: isNaN(n) ? Infinity : n, high: Infinity };
    }
    if (s.includes("-")) {
      const parts = s.split("-").map((p) => parseInt(p.replace(/[^0-9]/g, ""), 10));
      const low = isNaN(parts[0]) ? Infinity : parts[0];
      const high = isNaN(parts[1]) ? low : parts[1];
      return { low, high };
    }
    const v = parseInt(s.replace(/[^0-9]/g, ""), 10);
    return { low: isNaN(v) ? Infinity : v, high: isNaN(v) ? Infinity : v };
  };

  const compareRanges = (a, b) => {
    const A = parseRange(a);
    const B = parseRange(b);
    if (A.low !== B.low) return A.low - B.low;
    // if lows equal, put finite high before Infinity
    if (A.high === Infinity && B.high !== Infinity) return 1;
    if (B.high === Infinity && A.high !== Infinity) return -1;
    return A.high - B.high;
  };

  // Fetch all tables once
  const fetchTables = async () => {

    setLoading(true);
    try {
      const res = await axios.get(
        `${base_url}/tables/list-public`,
        { params: { table_type: "NO_HOST" } }
      );
      const items = res?.data?.items || [];
      setTables(items);

      // Small normalization to collapse weird whitespace and remove invisible chars

      // Extract unique event_date strings from items, normalize, parse and sort chronologically
      const normalizeEventDateString = (s) =>
        String(s || "")
          .replace(/\u200B|\uFEFF/g, "") // zero-width / BOM
          .replace(/\u00A0/g, " ") // no-break space
          .replace(/\s+/g, " ")
          .trim();

      const rawDates = Array.from(
        new Set(items.map((i) => normalizeEventDateString(i?.event_date)).filter(Boolean))
      );

      const parseEventDate = (s) => {
        if (!s) return null;
        // Accept formats like: "DD-MM-YYYY HH:MM" or "DD-MM-YYYY"
        const cleaned = String(s)
          .replace(/\u200B|\uFEFF/g, "") // zero-width / BOM
          .replace(/\u00A0/g, " ") // no-break space
          .replace(/\s+/g, " ")
          .trim();
        const parts = cleaned.split(" ");
        const datePart = parts[0] || "";
        const timePart = parts[1] || "";
        const datePieces = datePart.split("-").map((p) => parseInt(p, 10));
        if (datePieces.length < 3) return null;
        const [dd, mm, yyyy] = datePieces;
        const [hh = 0, min = 0] = (timePart || "").split(":").map((p) => parseInt(p, 10));
        if ([dd, mm, yyyy].some((n) => isNaN(n))) return null;
        return new Date(yyyy, mm - 1, dd, isNaN(hh) ? 0 : hh, isNaN(min) ? 0 : min);
      };


      // Fetch user's booked list and remove booked dates from the options
      try {
        const booked = await fetchUpcomingBookedList();
        setUpcomingTableList(booked);
        rawDates.sort((a, b) => {
          const A = parseEventDate(a);
          const B = parseEventDate(b);
          if (!A || !B) return 0;
          return A - B;
        });

        const now = new Date();
        // Collect booked dates (raw strings) for future bookings
        const bookedDates = (booked || [])
          .map((b) => b?.table_details?.event_date)
          .filter(Boolean)
          .map((s) => String(s)
            .replace(/\u200B|\uFEFF/g, "") // zero-width / BOM
            .replace(/\u00A0/g, " ") // no-break space
            .replace(/\s+/g, " ")
            .trim());

        // Find nearest upcoming booking (future date)
        const futureBooked = (booked || [])
          .map((b) => ({ raw: b?.table_details?.event_date, details: b }))
          .map((x) => ({ raw: x.raw, date: parseEventDate(x.raw), details: x.details }))
          .filter((x) => x.date && x.date > now)
          .sort((a, b) => a.date - b.date);

        if (futureBooked.length > 0) {
          setUpcomingBooking(futureBooked[0].details?.table_details || futureBooked[0].details);
        }

        const bookedSet = new Set(bookedDates);
        // Remove booked dates from API-provided dates (both normalized)
        let filteredDates = rawDates.filter((d) => !bookedSet.has(String(d)));

        // Only use API-provided dates. If all API dates are booked, leave the list empty
        setEventDates(filteredDates);
      } catch (err) {
        console.error("Error fetching booked list:", err);
        // if booking list fetch fails, fallback to rawDates
        setEventDates(rawDates);
      }

      // Unique price ranges - sort numerically by lower bound (e.g. 400-600, 600-1000, 1000+)
      const uniqueRanges = Array.from(new Set(items?.map((i) => i?.price_range)));
      uniqueRanges.sort(compareRanges);
      setPriceRanges(uniqueRanges);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch tables. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Fetch all tables once
  const fetchHostTables = async () => {

    setLoading(true);
    try {
      const res = await axios.get(
        `${base_url}/tables/list-public`
      );
      const items = res?.data?.items || [];
      setHostTables(items);

      if (items?.length) {
        // find upcoming Sunday's date 
        const today = new Date();
        const currentDay = today.getDay(); // 0 = Sunday, 1 = Monday, etc.

        // Calculate days until next Sunday
        const daysUntilSunday = currentDay === 0 ? 7 : 7 - currentDay;

        // Get the upcoming Sunday date
        const upcomingSunday = new Date(today);
        upcomingSunday.setDate(today.getDate() + daysUntilSunday);

        // Format the date to match the expected format (dd-mm-yyyy hh:mm)
        const formattedSunday = `${String(upcomingSunday.getDate()).padStart(2, '0')}-${String(upcomingSunday.getMonth() + 1).padStart(2, '0')}-${upcomingSunday.getFullYear()} 12:00`;

        // Add host table dates to existing eventDates
        setEventDatesHost([formattedSunday]);

        // setPreferredDay({ label: 'Sunday', iso: formattedSunday });
      }

    } catch (err) {
      console.error(err);
      setError("Failed to fetch tables. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTables();
    fetchHostTables();
  }, []);

  const selectArea = (a) => {
    setArea(a);
    // Filter tables by selected date (preferredDay.label) and mapped area
    const dateLabel = preferredDay?.label;
    const apiArea = AREA_MAP[a];
    let subset = tables.slice();
    if (dateLabel) {
      subset = subset.filter((t) =>
        String(t.event_date) === String(dateLabel)
      );
    }
    if (apiArea) {
      subset = subset.filter((t) => ((t.no_host_area || "").toLowerCase() === apiArea.toLowerCase()));
    }
    setCandidateTables(subset);

    // Compute price ranges from subset
    const uniqueRanges = Array.from(new Set(subset.map((i) => i.price_range).filter(Boolean)));
    uniqueRanges.sort(compareRanges);
    setPriceRanges(uniqueRanges);

    setStep(2); // move to price selection (day -> area -> price -> results)
  };

  const selectPriceRange = (pr) => {
    setPriceRange(pr);
    // Filter from candidateTables (already filtered by date+area)
    const source = (candidateTables && candidateTables.length > 0) ? candidateTables : tables;
    const filtered = source.filter((t) => t.price_range === pr);
    setFilteredTables(filtered);
    setStep(3);
    ReactPixel.track("Price", {
      model: 'NO_HOST'
    });
  };

  const handleBack = () => {
    if (step === 0) return onBack && onBack();
    if (step === 3) return setStep(2);
    if (step === 2) return setStep(1);
    setStep(0);
  };

  // Razorpay payment handler
  const handlePayment = (order_id, table) => {
    if (typeof window.Razorpay === "undefined") {
      toast.error("Razorpay SDK not loaded. Please refresh and try again.");
      return;
    }

    const RAZORPAY_KEY_ID = razorpay_key; // replace with live/test key
    const userName = localStorage.getItem("@userName") || "Guest User";
    const userPhone = localStorage.getItem("@userPhone") || "";
    const email = localStorage.getItem("email") || "";

    if (!email) {
      toast.warn("Please add your email before proceeding.");
      return;
    }

    const options = {
      key: RAZORPAY_KEY_ID,
      amount: table.price * 100,
      currency: "INR",
      name: "HighTable",
      description: "Booking Payment",
      order_id,
      image: "/images/High_Table_Logo.png",
      handler: async (response) => {
        console.log("Payment successful:", response);
        // capture payment on back-end
        await handleCheckPayment(response.razorpay_payment_id, table);
      },
      prefill: {
        name: userName,
        email,
        contact: userPhone,
      },
      theme: { color: "#F7C900" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
    rzp.on("payment.failed", (resp) => {
      toast.error(`Payment failed: ${resp?.error?.description || "Unknown error"}`);
      console.error(resp.error);
    });
  };

  // Book table API call
  const handleBookTable = async (table) => {
    const token = localStorage.getItem("@user");
    if (!token) {
      // open login flow (redirect to login page)
      setLoginModal(true);
      return;
    }

    try {
      const res = await axios.post(
        `${base_url}/table-booking/book-table`,
        { table_id: table.id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const orderId = res?.data?.details?.order_id;
      // mark booked and store order id
      setBookedMap((m) => ({ ...m, [table.id]: true }));
      if (orderId) {
        setOrderMap((m) => ({ ...m, [table.id]: orderId }));
        // start payment flow
        handlePayment(orderId, table);
      } else {
        toast.error("Booking failed. Try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Error booking table.");
    }
  };

  // Capture payment on backend and update state
  const handleCheckPayment = async (paymentId, table) => {
    try {
      // Extract booking_source from URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const bookingSource = urlParams.get("booking_source");

      const requestBody = { payment_id: paymentId };
      if (bookingSource) {
        requestBody.booking_source = bookingSource;
      }

      const res = await axios.post(
        `${base_url}/table-booking/capture-payment`,
        requestBody,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );


      setPayedMap((m) => ({ ...m, [table.id]: true }));
      setThanksModal(true);
      window.location.reload();
      // alert("Payment captured and booking confirmed.");

      setStatus("paid");
    } catch (err) {
      console.error("Error capturing payment:", err);
      toast.error("Error capturing payment. Please contact support.");
    }
  };

  const handleNavigate = (id) => {
    navigate(`/details?id=${id}`);
  };

  return (
    <div className="show-table-root w-full sm:max-w-4xl mx-auto px-4 py-8">
      {
        step > 0 &&
        <button
          onClick={handleBack}
          className="px-4 py-2 font-semibold text-lg bg-black text-white rounded-lg flex items-center gap-2 sm:-ml-20"
        >
          <FaArrowLeft /> Back
        </button>
      }
      {
        step === 0 && upcomingBooking &&
        <>
          <h3 className="text-2xl font-semibold text-gray-800 px-6 mb-16 -mt-16 ">Upcoming Bookings</h3>
          {upcomingTableList
            .filter((table) => {
              const eventDateStr = table?.table_details?.event_date;
              if (!eventDateStr) return false;
              const [date, time] = eventDateStr.split(' ');
              const [day, month, year] = date.split('-').map(Number);
              const [hour, minute] = time.split(':').map(Number);
              const eventDate = new Date(year, month - 1, day, hour, minute);
              return eventDate > new Date(); // keep only upcoming
            })
            .map((table) => (
              <UpcomingTable key={table.id} upcomingBooking={table} />
            ))}

        </>
      }


      {/* Step 0: Day selection */}
      {step === 0 && (
        <div>
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-4xl font-semibold text-black">Find tables near you</h2>
            {/* <button
              onClick={handleBack}
              className="px-3 flex items-center py-1 border rounded-md text-sm text-gray-700"
            >
              <BsArrowLeft size={22} />
              Back
            </button> */}
          </div>

          <h3 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4 mt-6"> Bangalore Tables: </h3>

          <DayQuestion
            dates={eventDates}
            onSelect={(label, iso) => {
              setPreferredDay({ label, iso });
              setSelectedDay(null);
              setStep(1);
            }}
          />

          {eventDatesHost && eventDatesHost?.length &&
            <div>
              <h3 className="text-2xl sm:text-3xl font-semibold text-gray-800 mb-4 mt-8"> Bangalore and Kochi Tables: </h3>
              <DayQuestion
                dates={eventDatesHost}
                onSelect={(label, iso) => {
                  setPreferredDay({ label, iso });

                  setSelectedDay('Sunday');
                  setStep(1);
                }
              }
              showHost={true}
              />
            </div>
          }

        </div>
      )}

      {/* Step 1: Area selection */}
      {step === 1 && (
        selectedDay === 'Sunday' ?
          <div className="w-full -ml-1 sm:-ml-16 pl-0">
            <br />
            <h3>Sunday special tables with HOST</h3>
            <div className="w-layout-grid table-category-grid">

              {hostTables.map((card, index) => (
                <div
                  key={index}
                  onClick={() => handleNavigate(card.id)}
                >
                  <ConcertCard slide={card} />
                </div>
              ))}
            </div>
          </div> :
          <div>
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-4xl font-semibold text-black pt-10">Find tables near you</h2>
              {
                ReactPixel.track("Profile", {
                  model: 'NO_HOST'
                })
              }
              <button
                onClick={handleBack}
                className="px-3 flex items-center py-1 border rounded-md text-sm text-gray-700 hidden"
              >
                <BsArrowLeft size={22} />
                Back
              </button>
            </div>
            <label className="block text-lg text-gray-500 font-medium mb-12 -mt-5">
              {/* Where are you located? */}
              {
                ReactPixel.track("Place", {
                  model: 'NO_HOST'
                })
              }
            </label>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 text-black">
              {AREAS.map((a) => (
                <div
                  key={a.key}
                  onClick={() => selectArea(a.key)}
                  className={`px-4 py-3 text-xl text-gray-600 cursor-pointer rounded-xl border-[#f7c900] border-4 text-left transition shadow-sm hover:shadow-md ${area === a.key ? "bg-[#f7c900] text-white" : "bg-gray-50"
                    }`}
                >
                  <div className="font-semibold">{a.label}</div>
                </div>
              ))}
            </div>
          </div>
      )}

      {/* Step 2: Price range */}
      {step === 2 && (
        <div className="mb-6 mt-5">
          <h2 className="text-4xl font-semibold text-black pt-10">Choose your preferred spend at the restaurant.</h2>
          <label className="block text-xl text-gray-700 font-medium mt-4 mb-10">

            Note: This range reflects your dining spend and doesn’t include the table booking fee.
          </label>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {
              priceRanges.length === 0 && (
                <div className="text-gray-500">No price ranges available for the selected date and area.</div>
              )
            }
            {priceRanges.map((pr) => (
              <div
                key={pr}
                onClick={() => selectPriceRange(pr)}
                className={`px-4 py-3 text-xl text-gray-600 cursor-pointer rounded-xl border-[#f7c900] border-4 text-left transition shadow-sm hover:shadow-md ${priceRange === pr ? "bg-[#f7c900] text-white" : "bg-gray-50"
                  }`}
              >
                <div className="font-semibold">₹{pr}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Step 3: Results */}
      {step === 3 && (
        <div>
          {error && <div className="text-red-600 mb-4">{error}</div>}

          {loading ? (
            <div className="text-gray-500">Loading...</div>
          ) : filteredTables.length === 0 ? (
            <div className="text-gray-600">No tables found.</div>
          ) : (
            filteredTables.map((table) => (
              <TableCard key={table.id} table={table} onBook={handleBookTable} status={status} setStatus={setStatus} />
            ))
          )}
        </div>
      )}


      {
        thanksModal && (
          <ThankYou
            onClose={() => setThanksModal(false)}
            tname={filteredTables[0]?.title}
            price={filteredTables[0]?.price}
          />
        )
      }
    </div>
  );
};

export default ShowTable;
